import React from 'react';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

export default CreateReactClass({
    displayName: 'class-family-report',

    PropTypes: {
        dropDowns: PropTypes.node.isRequired,
        nextButtonAction: PropTypes.func.isRequired,
        classSelected: PropTypes.bool,
    },

    render() {
        const containerClass = 'button-container show-tooltip';
        const tooltip = <div className="tooltip">No class selected</div>;
        const arrow = <div className="tooltip arrow" />;

        const { termDropdown, schoolDropdown, instructorDropdown, classDropdown } = this.props.dropDowns;

        return (
            <div className="class options-container">
                <div>
                    <h4>SELECT CLASS</h4>
                    {termDropdown}
                    {schoolDropdown}
                    {instructorDropdown}
                    {classDropdown}
                </div>
                <div className={containerClass}>
                    <button
                        className="button-next"
                        onClick={(event) => this.props.nextButtonAction(event, 'subjects')}
                        disabled={!this.props.classSelected}
                    >
                        NEXT
                    </button>
                    {!this.props.classSelected ? tooltip : null}
                    {!this.props.classSelected ? arrow : null}
                </div>
            </div>
        );
    },
});
